// 3rd Party
import React from 'react';

// Components
import { FormattedMessageV2 } from '@/views/components/i18n';

// Utils
import { LOCALE } from '@/utils/i18n';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  locale: string;
};

const SupportSection: React.FC<Props> = ({ locale }) => {
  const i18nBasePath = 'Modal.PortfolioAIStatementReader';
  const localePath = locale === LOCALE.FR_CA ? 'fr' : 'en';

  return (
    <div className="support-container">
      <FormattedMessageV2 tagName={ALLOWED_HTML_TAGS.SPAN} toLocalize={`${i18nBasePath}.Support.ByClickingContinue`} />
      <a className="support-link" href={`https://capintel.com/${localePath}/terms`} target="_blank" rel="noopener noreferrer">
        <FormattedMessageV2 tagName={ALLOWED_HTML_TAGS.SPAN} toLocalize={`${i18nBasePath}.Support.Terms`} />
      </a>
      <FormattedMessageV2 tagName={ALLOWED_HTML_TAGS.SPAN} toLocalize={`${i18nBasePath}.Support.And`} />
      <a className="support-link" href={`https://capintel.com/${localePath}/privacy`} target="_blank" rel="noopener noreferrer">
        <FormattedMessageV2 tagName={ALLOWED_HTML_TAGS.SPAN} toLocalize={`${i18nBasePath}.Support.PrivacyPolicy`} />
      </a>
    </div>
  );
};

export default SupportSection;
